import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.review-screen-standard.heading',
		defaultMessage: 'Review project details',
		description: 'Title of Review Details',
	},
	description: {
		id: 'project-create-importer-upload-flow.review-screen-standard.description',
		defaultMessage:
			'We’re ready to import your team’s data. Here’s a summary of what’s being imported into Jira. Confirm the details before starting the import.',
		description: 'Description of Review Details',
	},
});
